// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SearchComponent} from './Search.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSearch = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SearchComponent/>
  </Icon>
));
